import React from "react";
import "../../styles/PlacementNetworking.css"; 

const AddOnCourses = () => {
// Section 1: English Communication Data
  const englishData = [
    {
      id: 1,
      title: "Grammar & Vocabulary Enhancement",
      // Image: A notebook/writing setting representing study and vocabulary
      img: "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 2,
      title: "Spoken English Practice Sessions",
      // Image: People engaging in conversation/discussion
      img: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 3,
      title: "Business Email & Report Writing",
      // Image: Professional typing on a laptop, office environment
      img: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 4,
      title: "Public Speaking & Group Discussions",
      // Image: A microphone or speaker setup
      img: "https://i.pinimg.com/736x/14/d4/42/14d442b71379f232e4d97d5f8179412c.jpg"
    }
  ];

  // Section 3: Admissions & Fees Data
  const admissionData = [
    {
      id: 1,
      title: "Eligibility",
      desc: "Open to school students (from 8th standard onwards), graduates, job seekers, and working professionals",
      // Image: Diverse group of students/people representing "Everyone is welcome"
      img: "https://i.pinimg.com/1200x/7b/2f/97/7b2f9761ba541a051c58ebf9a918a8cf.jpg"
    },
    {
      id: 2,
      title: "Duration",
      desc: "Short-term & long-term programs available",
      // Image: Clock or calendar representing time/duration
      img: "https://i.pinimg.com/1200x/c5/f2/91/c5f29172e7b7efaa3cf8b6a0ba018ab8.jpg"
    },
    {
      id: 3,
      title: "Fee Structure",
      desc: "Affordable with installment options",
      // Image: Calculator/Finance/Piggybank concept
      img: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 4,
      title: "How to Apply",
      desc: "Call +91 7708941960 or email admission@madhiacademy.com",
      // Image: Hands holding a phone or contacting
      img: "https://images.unsplash.com/photo-1516387938699-a93567ec168e?auto=format&fit=crop&w=800&q=80"
    }
  ];

  return (
    <section className="addon-section container">
      
      {/* --- SECTION 1: English Communication --- */}
      <div className="text-center mb-5">
        <h2 className="addon-main-title mb-3">
          English Communication
        </h2>
        <h5 className="fw-bold text-dark mb-2">Speak, Write, and Present with Confidence</h5>
        <p className="text-muted mx-auto" style={{ maxWidth: "800px" }}>
          Our English Communication program focuses on real-life communication skills that help you excel in interviews, presentations, and professional settings.
        </p>
        <p className="fw-bold text-dark mt-3">You Will Learn:</p>
      </div>

      <div className="addon-grid mb-5">
        {englishData.map((item) => (
          <div key={item.id} className="addon-card">
            <div className="addon-img-box">
              <img src={item.img} alt={item.title} className="addon-img" />
            </div>
            <div className="addon-content">
              <h6 className="addon-title">{item.title}</h6>
            </div>
          </div>
        ))}
      </div>

      {/* --- SECTION 2: Corporate Training (Text Only) --- */}
      <div className="text-center py-5 my-4 border-top border-bottom">
        <h2 className="addon-main-title mb-3">Corporate Training</h2>
        <p className="text-muted mx-auto" style={{ maxWidth: "800px" }}>
          We also offer customized training solutions for corporates to upgrade their employees' ERP, computer, and communication skills.
        </p>
      </div>

      {/* --- SECTION 3: Admissions & Fees --- */}
      <h2 className="addon-main-title text-center mt-5 mb-4">
        Admissions & Fees
      </h2>

      <div className="addon-grid">
        {admissionData.map((item) => (
          <div key={item.id} className="addon-card">
            <div className="addon-img-box">
              <img src={item.img} alt={item.title} className="addon-img" />
            </div>
            <div className="addon-content">
              <h5 className="addon-title">{item.title}</h5>
              <p className="addon-desc small">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

    </section>
  );
};

export default AddOnCourses;